import React from "react";
import axios from "@/utils/myAxios";
import moment from "moment";
import Cookie from "js-cookie";
import { Link } from "react-router-dom";
import { pageSizeList } from "@/utils/constant";
import { Button, Table, message, DatePicker, Pagination, Select } from "antd";
import { tableSummaries, isMobileDevice } from "@/utils/utils";

export default class PaymentStatistic extends React.Component {
    state = {
        loading: false, // 是否加载中
        exportLoading: false, // 导出是否加载中
        queryParams: {
            // 查询参数
            page: 1,
            limit: 7,
            total: 0,
            date: [],
        },
        data: [], // 表格数据
        pageSizeList: pageSizeList, // 分页天数列表
    };

    componentDidMount () {
        this.fetchData();
    }

    /**
     * 获取数据
     */
    fetchData = () => {
        this.setState({ loading: true });
        axios
            .get("/v1/api/kpoker_union/up_gain_stat", {
                params: {
                    ...this.state.queryParams,
                    begin_time:
                        this.state.queryParams.date[0] &&
                        this.state.queryParams.date[0].startOf("day").valueOf() / 1000,
                    end_time:
                        this.state.queryParams.date[1] &&
                        this.state.queryParams.date[1].startOf("day").valueOf() / 1000,
                    total: undefined,
                    date: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    loading: false,
                    queryParams: { ...this.state.queryParams, total: res.count || 0 },
                    data: res.data || [],
                });
            });
    };

    /**
     * 导出数据
     */
    handleExport = () => {
        this.setState({ exportLoading: true });
        axios
            .get("/v1/api/kpoker_union/up_gain_stat_export", {
                params: {
                    ...this.state.queryParams,
                    begin_time:
                        this.state.queryParams.date[0] &&
                        this.state.queryParams.date[0].startOf("day").valueOf() / 1000,
                    end_time:
                        this.state.queryParams.date[1] &&
                        this.state.queryParams.date[1].startOf("day").valueOf() / 1000,
                    total: undefined,
                    date: undefined,
                },
            })
            .then((res) => {
                this.setState({ exportLoading: false });
                if (res.code === 1) {
                    message.success(this.props.language["exportSuccessMessage"]);
                    window.open(process.env.REACT_APP_API_URL + res.url);
                }
            });
    };

    /**
     * 改变分页
     */
    hanldeChangePage = (pagination) => {
        this.setState(
            {
                queryParams: {
                    ...this.state.queryParams,
                    page: pagination.current,
                    limit: pagination.pageSize,
                },
            },
            () => this.fetchData()
        );
    };

    /**
     * 设置查询数据
     */
    handleSetQueryParamsData = (key, value) => {
        this.setState({
            queryParams: { ...this.state.queryParams, page: 1, [key]: value },
        });
    };

    /**
     * 重置
     */
    handleReset = () => {
        this.setState(
            {
                queryParams: {
                    page: 1,
                    limit: 7,
                    total: 0,
                    date: [],
                },
            },
            () => {
                this.fetchData();
            }
        );
    };

    render () {
        return (
            <div className="main-container">
                {/* 表头 */}
                <div className="container-header">
                    <DatePicker.RangePicker
                        value={this.state.queryParams.date}
                        onChange={(e) => this.handleSetQueryParamsData("date", e)}
                    />
                    <Button
                        type="primary"
                        icon="search"
                        loading={this.state.loading}
                        onClick={this.fetchData}
                    >
                        {this.props.language["query"]}
                    </Button>
                    <Button type="default" icon="reload" onClick={this.handleReset}>
                        {this.props.language["reset"]}
                    </Button>
                    <Button
                        type="default"
                        icon="arrow-down"
                        className="btn-yellow-ghost"
                        loading={this.state.exportLoading}
                        onClick={this.handleExport}
                    >
                        {this.props.language["exportExcel"]}
                    </Button>
                </div>

                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={tableSummaries(this.state.data, "day")}
                        pagination={false}
                        loading={this.state.loading}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column
                            align="center"
                            title={this.props.language["date"]}
                            dataIndex="day"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["totalGaveIn"]}
                            dataIndex="total_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["activityCost"]}
                            dataIndex="active_cost"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["playerProfit"]}
                            dataIndex="profit_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["serviceProportion"]}
                            dataIndex="fee_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["insuranceProportion"]}
                            dataIndex="ins_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["cowboyProportion"]}
                            dataIndex="cowboy_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["luckcardAndJackpotProfit"]}
                            dataIndex="lc_jp_gain_sum"
                        />
                        {Cookie.get("isKpoker") === 'true' &&
                            <Table.Column
                                align="center"
                                title={this.props.language["propCusomeGiveIn"]}
                                dataIndex="api_prop_cost_gain_sum"
                            />
                        }
                        <Table.Column
                            align="center"
                            title={this.props.language["nlhProfit"]}
                            dataIndex="nlh_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["squidProfit"]}
                            dataIndex="squid_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["superProfit"]}
                            dataIndex="super_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["aofProfit"]}
                            dataIndex="aof_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["ofcProfit"]}
                            dataIndex="ofc_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["mttProfit"]}
                            dataIndex="mtt_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["ploProfit"]}
                            dataIndex="plo_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["sixProfit"]}
                            dataIndex="six_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["cowboyProfit"]}
                            dataIndex="cb_profit_sum"
                        />
                        {Cookie.get("isKpoker") === 'true' &&
                            <Table.Column
                                align="center"
                                title={this.props.language["prop"]}
                                dataIndex="api_prop_cost_sum"
                            />
                        }
                        <Table.Column
                            align="center"
                            title={this.props.language["nlhDeductFee"]}
                            dataIndex="nlh_fee_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["squidDeductFee"]}
                            dataIndex="squid_fee_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["superDeductFee"]}
                            dataIndex="super_fee_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["aofDeductFee"]}
                            dataIndex="aof_fee_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["ofcDeductFee"]}
                            dataIndex="ofc_fee_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["mttDeductFee"]}
                            dataIndex="mtt_fee_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["ploDeductFee"]}
                            dataIndex="plo_fee_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["sixDeductFee"]}
                            dataIndex="six_fee_gain_sum"
                        />
                        {/* <Table.Column align="center" title={this.props.language["cowboyDeductFee"]} dataIndex="cb_fee_sum" /> */}
                        <Table.Column
                            align="center"
                            title={this.props.language["nlhDeductInsurance"]}
                            dataIndex="nlh_ins_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["squidDeductInsurance"]}
                            dataIndex="squid_ins_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["superDeductInsurance"]}
                            dataIndex="super_ins_gain_sum"
                        />
                        {/* <Table.Column align="center" title={this.props.language["aofDeductInsurance"]} dataIndex="aof_ins_profit_sum" /> */}
                        {/* <Table.Column align="center" title={this.props.language["ofcDeductInsurance"]} dataIndex="ofc_ins_fee_sum" /> */}
                        {/* <Table.Column align="center" title={this.props.language["mttDeductInsurance"]} dataIndex="mtt_ins_profit_sum" /> */}
                        <Table.Column
                            align="center"
                            title={this.props.language["ploDeductInsurance"]}
                            dataIndex="plo_ins_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["sixDeductInsurance"]}
                            dataIndex="six_ins_gain_sum"
                        />
                        {/* <Table.Column align="center" title={this.props.language["cowboyDeductInsurance"]} dataIndex="cb_ins_profit_sum" /> */}
                    </Table>
                    <div className="pagination">
                        <Pagination
                            showQuickJumper
                            size={isMobileDevice() ? 'small' : ''}
                            showTotal={(total) =>
                                `${this.props.language["total"]} ${total} ${this.props.language["day"]}`
                            }
                            current={this.state.queryParams.page}
                            pageSize={this.state.queryParams.limit}
                            total={this.state.queryParams.total}
                            onChange={(current, pageSize) =>
                                this.hanldeChangePage({ current, pageSize })
                            }
                        />
                        {!isMobileDevice() &&
                            <Select
                                className="ml10"
                                value={this.state.queryParams.limit}
                                onChange={(value) =>
                                    this.hanldeChangePage({ current: 1, pageSize: value })
                                }
                            >
                                {this.state.pageSizeList.map((item, index) => (
                                    <Select.Option value={item.value} key={index}>
                                        {item.label}
                                    </Select.Option>
                                ))}
                            </Select>
                        }
                    </div>
                </div>
            </div>
        );
    }
}
